module.exports = __webpack_public_path__ + "static/media/IMG_1466.e8bc35bb.JPG";